// Prop types and unused state are disabled because they are used in common.js
// no-named-as-default-member is disabled to distinguish common methods from class methods

/* eslint-disable
   react/sort-comp,
   react/no-unused-prop-types,
   react/no-unused-state,
   import/no-named-as-default-member
*/

import React, { useEffect } from 'react';
import { View } from 'react-native';
import NextgenEpgContainer from 'LocalGluons/components/Epg/index.web';
import { ActivityIndicator } from 'LocalGluons';
import { withStore } from 'Store';
import utils, {
    areFavoritesEqual,
    customFilterAdapter,
    filterCategoriesChannelsByChannels,
    getEpgMaxDaysBack
} from 'Utils/epgUtils';
import { t } from 'Locale';
import { withFavoriteChannelsContext } from 'LocalGluons/components/FavoriteChannelsContext/FavoriteChannelsContext';
import EpgWrapper from 'LocalGluons/components/EpgContainer/components/EpgWrapper';
import tabletTheme from 'Theme/themeEpg.tablet.ios';
import { withRecordings } from 'LocalGluons/components/RecordingsContext/RecordingsContext';
import { withNotifications } from 'LocalGluons/components/NotificationsContext/NotificationsContext';
import common from 'LocalGluons/components/EpgContainer/common';
import { logEvent } from 'AppManager';
import { useIsFocused } from '@react-navigation/native';
import NavigationService from 'NavigationService';
import { TOP_BAR_TOTAL_HEIGHT } from '../../../runtime/Navigation/Menu/Menu.styles';
import DatePicker from './components/DatePicker.web';
import Filter from './components/Filter/Filter.web';
import DetailsPopup from './components/DetailsPopup';
import EPGThemeWeb from '../../../Theme/themeEpg.web';
import { EPG_LIST_TYPES } from '../../../options';
import defaultStyles from './EpgContainer.jss';
import { withAppErrorHandler } from '../../../runtime/App/AppErrorHandlerContext/AppErrorHandlerContext';
import { withConfirmationModal } from '../ConfirmationModal';

const initializeCanvas = () => {
    const canvas = document.createElement('canvas');
    canvas.id = 'scrollSync';
    canvas.style.position = 'absolute';
    canvas.style.top = 0;
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.pointerEvents = 'none';
    document.body.appendChild(canvas);
};

const getDefaultState = (props) => ({
    selectedDate: new Date(),
    currentTime: new Date(),
    epgItems: [],
    epgFetchState: utils.EPG_FETCH_STATE.DONE,
    displayDatePicker: false,
    displayFilters: false,
    displayDetails: false,
    selectedCell: {},
    listMode: props.epgSelectedListMode || utils.DEFAULT_LIST_MODE,
    categories: [],
    allChannels: [],
    liveChannels: [],
    filteredChannels: props.epgFilteredChannels,
    liveChannelId: null,
    currentBriefChannel: null
});
class EpgContainer extends React.Component {
    static defaultProps = common.defaultProps;

    static propTypes = common.propTypes;

    constructor(props) {
        super(props);
        this.offset = utils.INITIAL_EPG_OFFSET;
        this.filterIsUsed = props.epgFilteredChannels.length > 0;
        this.state = getDefaultState(props);
        this.navWillFocusListener = null;
        this.totalItemsCount = 0;
        this.isFetchingRest = true;
        this.subscriberId = 'tv-guide-component';
        this.epgRef = {};
        this.comesFromSearch = false;
        this.initFromSearchCalled = false;
        this.initOnChangeCalled = false;
    }

    getDefaultCategories = async () => common.getDefaultCategories(this);

    onListModeSelected = (listMode) => common.onListModeSelected(this, listMode);

    onCheckFilter = (index) => common.onCheckFilter(this, index);

    onResetFilter = (resetList) => common.onResetFilter(this, resetList);

    initChannelsBrief = async () => common.initChannelsBrief(this);

    fetchUserFavorites = async (filteredChannels) =>
        common.fetchUserFavorites(this, filteredChannels);

    popupDetails = (cell) => common.popupDetails(this, cell);

    setNavigationParams = () => {
        const { navigation, epgFilteredChannels } = this.props;
        navigation.setParams({
            filterActive: epgFilteredChannels.length > 0
        });
    };

    getFilteredCategories = async () => {
        const { appManager, userData, setCategories, epgFilters } = this.props;
        if (epgFilters?.length) {
            try {
                const api = appManager.getApi();
                const { categories } = await api.getCategories(
                    userData ? userData.lang : utils.DEFAULT_LANGUAGE
                );
                const newCategories = categories?.map((category) => {
                    category.selected = epgFilters.some((filter) => filter.id === category.id);
                    return category;
                });
                setCategories(newCategories);
                this.setState({ categories: newCategories });
                return newCategories;
            } catch (error) {
                console.log(error);
            }
        } else {
            return this.getDefaultCategories();
        }
    };

    initFromSearch = async () => {
        const { route } = this.props;
        const { selectedDate, liveChannels } = this.state;
        const liveChannelId = route.params?.searchParams?.liveChannelId;
        this.setState({
            liveChannelId
        });
        if (liveChannelId) {
            const index = liveChannels.findIndex((channel) => channel?.channelId === liveChannelId);
            if ((index !== -1 && index > utils.DEFAULT_EPG_LIMIT) || this.filterIsUsed) {
                await this.fetchEpgFromOffset(index, selectedDate, 1, false, false, liveChannelId);
            }
            return;
        }
        await this.epgFromSearch();

        await this.getFilteredCategories();
        this.setState({ deviceType: 'web', liveChannelId });
    };

    init = async () => {
        const { recordings, updateRecordings, appManager } = this.props;
        const { selectedDate, epgItems } = this.state;
        this.setNavigationParams();
        initializeCanvas();
        if (recordings.length === 0) updateRecordings();
        await this.fetchEpgFromOffset(utils.INITIAL_EPG_OFFSET, selectedDate);
        const { allChannels, liveChannels } = await this.initChannelsBrief();
        this.setState({ allChannels, liveChannels }, this.initFromSearch);
        logEvent({
            type: 'user-flow',
            subtype: 'epg',
            content1: 'epg-browse-by-channel',
            content2: 'select',
            context: '/epg'
        });
    };

    async componentDidMount() {
        const { navigation } = this.props;
        NavigationService.setAppNavigationInstance(navigation);
        this.init();
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            favoriteChannels,
            setEpgSelectedListMode,
            epgFilteredChannels,
            navigation,
            route,
            epgFilters
        } = this.props;
        const { listMode, filteredChannels, epgItems, categories } = this.state;
        const isDifferentListMode = prevState.listMode !== listMode;
        if (prevProps.route !== route) {
            if (!this.initOnChangeCalled) {
                this.initOnChangeCalled = true;
                this.init();
            }
        }
        // If the listMode changes, reinitialize the component
        if (isDifferentListMode) {
            navigation.navigate('rootStack', { screen: 'TvGuide' });
            this.setState(getDefaultState(this.props), this.init);
            setEpgSelectedListMode(listMode);
            this.setNavigationParams();
            return;
        }

        if (prevProps.epgFilteredChannels !== epgFilteredChannels) {
            this.setNavigationParams();
            this.refreshData();
            return;
        }

        if (prevState.filteredChannels.length !== filteredChannels.length) {
            this.refreshData();
            return;
        }

        const prevLiveChannelId = prevProps?.route?.params?.searchParams?.liveChannelId;
        const liveChannelId = route.params?.searchParams?.liveChannelId;

        if (
            prevLiveChannelId === undefined &&
            liveChannelId &&
            prevLiveChannelId !== liveChannelId
        ) {
            this.setState(getDefaultState(this.props), this.init);
            return;
        }

        if (listMode === EPG_LIST_TYPES.FAVORITES) {
            if (!areFavoritesEqual(prevProps.favoriteChannels, favoriteChannels)) {
                this.refreshData(true);
            }
        }

        const navigationState = navigation.getState();
        const routesLength = navigationState.routes.length;

        if (navigationState.routes.length > 1) {
            const previousRoute = navigationState.routes[routesLength - 2];
            if (previousRoute.name === 'Search') {
                this.comesFromSearch = true;
            }
        }
        if (categories.length === 0 && !this.initFromSearchCalled) {
            this.initFromSearchCalled = true;
            this.getFilteredCategories();
        }
    }

    componentWillUnmount() {
        if (this.navWillFocusListener) this.navWillFocusListener();
        document.body.removeChild(document.getElementById('scrollSync'));
    }

    refreshData = (forceFetch = false) => {
        const { selectedDate } = this.state;
        this.fetchEpgFromOffset(0, selectedDate, utils.DEFAULT_EPG_LIMIT, true, forceFetch);
    };

    onVerticalEndReached = () => {
        const { epgFetchState, selectedDate } = this.state;
        if (epgFetchState !== utils.EPG_FETCH_STATE.END_REACHED && !this.isFetchingRest) {
            this.isFetchingRest = true;
            this.setState({ epgFetchState: utils.EPG_FETCH_STATE.LOADING });
            this.fetchEpgFromOffset(this.offset, selectedDate);
        }
    };

    // Categories must be filtered by selected list mode,
    // by default categories has channels from 'all' list
    filterCategoriesByListMode = (categories) => {
        const { liveChannels, listMode } = this.state;
        const { favoriteChannels } = this.props;
        if (listMode === EPG_LIST_TYPES.ALL) {
            return categories;
        }
        return filterCategoriesChannelsByChannels(
            categories,
            listMode === EPG_LIST_TYPES.LIVE ? liveChannels : favoriteChannels
        );
    };

    toggleFilters = () => {
        const { displayFilters, displayDatePicker } = this.state;
        if (displayDatePicker && !displayFilters) {
            this.setState({
                displayDatePicker: false,
                displayFilters: !displayFilters
            });
            return;
        }
        this.setState({ displayFilters: !displayFilters });
    };

    filterByDate = (opt) => {
        this.offset = utils.INITIAL_EPG_OFFSET;
        this.isFetchingRest = false;
        this.setState(
            {
                epgItems: [],
                epgFetchState: utils.EPG_FETCH_STATE.DONE,
                selectedDate: opt.filters[0].value
            },
            () => {
                this.fetchEpgFromOffset(this.offset, opt.filters[0].value);
            }
        );
    };

    filter = (opt) => {
        this.epgRef.filter(opt);
    };

    fetchEpgFromOffset = async (
        offset,
        dateFrom = null,
        limit = utils.DEFAULT_EPG_LIMIT,
        reset = false,
        forceFetch = false
    ) => common.fetchEpgFromOffset(this, offset, dateFrom, limit, reset, forceFetch);

    hidePopupDetails = () => {
        this.setState({ displayDetails: false });
    };

    epgFromSearch = async () => {
        const { navigation } = this.props;
        const nav = navigation.getState();
        const routesLength = nav.routes.length;

        if (nav.routes.length > 1 && nav.routes[routesLength - 2].name === 'Search') {
            this.setState({
                curentlyLiveItem:
                    nav.routes[routesLength - 2].params?.searchParams.curentlyLiveItem,
                liveChannelId: this.state.liveChannelId
            });
        }
    };

    selectedChannelResolver = (allChannels) =>
        allChannels.find((channel) => channel.channelId === this.state.liveChannelId);

    render() {
        const {
            navigation,
            mCoreConfig,
            favoriteChannels,
            recordingIds,
            notifications,
            parentalLockConfig,
            appManager
        } = this.props;
        const {
            currentTime,
            displayDatePicker,
            displayDetails,
            epgFetchState,
            epgItems,
            selectedCell,
            selectedDate,
            listItems,
            categories,
            listMode,
            allChannels,
            liveChannels,
            currentBriefChannel
        } = this.state;
        const { END_REACHED } = utils.EPG_FETCH_STATE;
        const maxDaysBack = getEpgMaxDaysBack(mCoreConfig);

        const extendedEpgItems = utils.extendEpgItems(
            epgItems,
            recordingIds,
            notifications,
            parentalLockConfig,
            appManager.getApi().getSessionConfig(),
            categories
        );

        const filteredEpgItems = extendedEpgItems.filter((item) => item.programs.length);
        const hideChannelListTypeAll = Boolean(mCoreConfig?.hideChannelListTypeAll);

        return (
            <EpgWrapper>
                {displayDetails && (
                    <DetailsPopup
                        style={defaultStyles.detailsPopup}
                        cell={selectedCell}
                        onClose={this.hidePopupDetails}
                        navigation={navigation}
                        lowLatency={currentBriefChannel?.lowLatency}
                    />
                )}
                <DatePicker
                    daysBack={maxDaysBack}
                    now={currentTime}
                    changeDate={this.filterByDate}
                    selectedDate={selectedDate}
                />
                <NextgenEpgContainer
                    loadingIndicator={() => null}
                    data={filteredEpgItems}
                    theme={EPGThemeWeb}
                    landscapeTheme={EPGThemeWeb}
                    currentTime={currentTime}
                    selectedDate={selectedDate}
                    currentTimeLabelText={t('COMMON.NOW')}
                    lockedContentTitle={t('COMMON.LOCKED_CONTENT')}
                    forceDataUpdate={new Date().getTime()}
                    ref={(ref) => {
                        this.epgRef = ref;
                    }}
                    onPressCell={this.popupDetails}
                    customFilterAdapter={customFilterAdapter}
                    isFetchingDone={epgFetchState === END_REACHED}
                    onVerticalEndReached={this.onVerticalEndReached}
                    secondLayer={() => (
                        <Filter
                            datePickerHeight={tabletTheme.datePicker.window.line.height || 60}
                            displayDatePicker={displayDatePicker}
                            categories={this.filterCategoriesByListMode(categories)}
                            onCheckFilter={this.onCheckFilter}
                            toggleFilters={this.toggleFilters}
                            listMode={listMode}
                            listItems={listItems}
                            onListModeSelected={this.onListModeSelected}
                            allChannels={allChannels}
                            liveChannels={liveChannels}
                            favoriteChannels={favoriteChannels}
                            onReset={this.onResetFilter}
                            theme={EPGThemeWeb.filters}
                            hideChannelListTypeAll={hideChannelListTypeAll}
                            filterIsUsed={this.filterIsUsed}
                        />
                    )}
                    selectedChannel={this.selectedChannelResolver(allChannels)}
                    comesFromSearch={this.comesFromSearch}
                    idOfSelectedChannel={this.state.liveChannelId}
                />
            </EpgWrapper>
        );
    }
}

const EpgContainerWithStoreContext = withStore(EpgContainer);
const EpgContainerWithFavoriteChannelsContext = withFavoriteChannelsContext(
    EpgContainerWithStoreContext
);
const EpgContainerWithRecordings = withRecordings(EpgContainerWithFavoriteChannelsContext);
const EpgContainerWithNotifications = withNotifications(EpgContainerWithRecordings);
const EpgContainerWithConfirmationModal = withConfirmationModal(EpgContainerWithNotifications);
const EpgContainerCompleter = withAppErrorHandler(EpgContainerWithConfirmationModal);

export default function (props) {
    const isFocused = useIsFocused();

    return isFocused ? <EpgContainerCompleter {...props} /> : null;
}
